<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-google-maps</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.map') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <v-slider
        style="padding-top: 20px"
        v-model="content.MapHeight"
        :color="enterpriseColor"
        :label="$t('common.height')"
        min="0"
        max="1000"
        thumb-label
        @input="handleChangeIsModified"
      />
    </v-toolbar>
    <div v-show="!collapseContent" style="margin: 0 -10px;background-color:#EAEAEA; padding: 20px 15px 0 15px;">
      <div style="padding: 0 10px 0 10px;">  
        <address-find
          :id="content.ID"
          :onUpdateAddress="handleUpdateAddress"
        />
      </div>
      <v-layout align-center wrap style="margin-top: -10px;padding:0 0px 20px 0px;">
        <v-flex xs6 style="padding-right: 5px;">
        <v-text-field
          v-model="content.Lat"
          append-icon="mdi-search"
          :label="$t('map.lat')"
          hideDetails
          @input="handleChangeIsModified"
        />
        </v-flex>
        <v-flex xs6 style="padding-left: 5px;">
        <v-text-field
          v-model="content.Lon"
          append-icon="mdi-search"
          :label="$t('map.lon')"
          hideDetails
          @input="handleChangeIsModified"
        />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import AddressFind from '@/components/AddressFind'
  export default {
    components: {
      AddressFind
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      },
      handleUpdateAddress (address) {
        this.content.Lat = address.lat
        this.content.Lon = address.lon
      }
    }
  }
</script>

<style scoped>
</style>

